<template>
   <v-container fluid>
      <v-toolbar dense :color="$globalstore.settings_titleclass">
         <v-toolbar-title>
            <template v-if="$vuetify.breakpoint.mobile">
               <v-icon large class="mr-2" @click="goBack()">mdi-chevron-left</v-icon>
            </template>
            Default Messages
         </v-toolbar-title>
      </v-toolbar>
      <v-row class="pt-1 mt-1">
         <v-col cols="12" md="12">
            <v-data-table
               dense
               :headers="message_headers"
               :items="messagedata"
               item-key="id"
               :items-per-page="itemPageCount"
               single-select
               @click:row="messageRowClick"
               @update:items-per-page="itemPerPageChange"
            >
               <!-- eslint-disable-next-line -->
               <template #item.actions="{ item }">
                  <v-icon small @click="editMessage(item)">mdi-pencil</v-icon>
               </template>
            </v-data-table>
         </v-col>
      </v-row>
   </v-container>
</template>

<script>
   export default {
      inject: ["ShowMessage"],

      data() {
         return {
            DEPT: {
               CCA: 1,
               BILLING: 2,
            },

            message_headers: [
               {
                  text: "Name",
                  value: "messagename",
                  width: "35%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Remarks",
                  value: "remarks",
                  width: "45%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Subject",
                  value: "messagesubject",
                  width: "10%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "10%",
                  class: this.$globalstore.table_headerclass,
               },
            ],
            itemPageCount: this.$globalstore.defaultmessage.itemsperpage || 10,
            messagedata: [],
         };
      },

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         messageRowClick(item, row) {
            row.select(!row.isSelected);
         },

         itemPerPageChange(count) {
            this.$globalstore.defaultmessage.itemsperpage = count;
         },

         editMessage(item) {
            this.$router.push({
               name: "EditDefaultMessage",
               params: {message: item},
            });
         },

         async loadDefaultMessages() {
            await this.$http({
               url: "/common/getdefaultmessage.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  dept: this.DEPT.CCA,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.messagedata = response.data.messagedata;
                  }
               }
            });
         },
      },

      mounted() {
         this.loadDefaultMessages();
      },
   };
</script>
